import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { getDefaultArtByType } from '../../../../../lib/ArtUtils';
import * as D from '../../../deps';

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
const ArtistSimilarArtistRowItem = props => {
  return (
    <D.RowItem
      isImgCircle={true}
      imgUrl={props.imgUrl || getDefaultArtByType(D.PandoraTypes.ARTIST)}
      mainText={props.name}
      rowUrl={props.urlPath}
      isWidthHalf={true}
      hasBorderTopBottom={true}
      sourceCardMenuItems={props.sourceCardMenuItems}
    />
  );
};

ArtistSimilarArtistRowItem.propTypes = {
  pandoraId: PropTypes.string,
  imgUrl: PropTypes.string,
  name: PropTypes.string,
  urlPath: PropTypes.string,
  sourceCardMenuItems: PropTypes.object,
};

// @ts-expect-error TS(7006) FIXME: Parameter 'state' implicitly has an 'any' type.
export function mapStateToProps(state, ownProps) {
  const sourceCardMenuItems = D.getSourceCardMenuItems({
    state,
    pandoraId: ownProps.pandoraId,
    pandoraType: D.PandoraTypes.ARTIST,
    shareParentSource: {
      shareParentSourceId: ownProps.pandoraId,
      shareParentSourceType: D.PandoraTypes.ARTIST,
    },
  });

  return { sourceCardMenuItems };
}

export default connect(mapStateToProps)(ArtistSimilarArtistRowItem);
